// Grid Switcher
if (!customElements.get('grid-switcher')) {
  customElements.define(
    'grid-switcher',
    class GridSwitcher extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.buttons = this.querySelectorAll('[data-grid-toggle]');
        this.grid = document.querySelector('[data-products-grid]');

        // Set initial active state from URL param
        const params = new URLSearchParams(window.location.search);
        const savedColumns = params.get('grid_columns');
        if (savedColumns) {
          this.applyColumns(savedColumns, false);
        }

        this.buttons.forEach((btn) => {
          btn.addEventListener('click', this.handleClick);
        });
      }

      disconnectedCallback() {
        this.buttons.forEach((btn) => {
          btn.removeEventListener('click', this.handleClick);
        });
      }

      handleClick(e) {
        const btn = e.target.closest('[data-grid-toggle]');

        if (!btn) return;
        this.applyColumns(btn.dataset.gridColumns);
      }

      applyColumns(columns, persist = true) {
        if (!this.grid) return;

        this.grid.style.setProperty('--COLUMNS', columns);

        this.buttons.forEach((btn) => {
          btn.classList.toggle('is-active', btn.dataset.gridColumns === columns);
          btn.setAttribute('aria-pressed', btn.dataset.gridColumns === columns);
        });

        if (persist) {
          const url = new URL(window.location.href);
          url.searchParams.set('grid_columns', columns);
          window.history.replaceState({}, '', url);
        }
      }
    },
  );
}
